import axios from 'axios'

export const state = {
  permissions : {},
}

export const getters = {
  listPermissions (state) {
    return state.permissions
  },
}

export const mutations = {
  SET_PERMISSIONS (state, permissions) {
    state.permissions = permissions
  },
}

export const actions = {
  getPermissions() {
    return axios.get(`/permissions`)
  },
}
